module.exports = {
    // basic
    'highlight-remarks-within-results': 'highlight remarks matches within results',
    'return-only-matching-files': 'return only matching files',
    'not': 'not',
    'well-add-date': 'well add date',
    'other-properties': 'other properties',
    'property': 'property',
    'add-property': 'add property',
    // raw
    'saved-search-new-help': 'Save the above search criteria.',
    'saved-search-existing-help': 'Save changes to, or delete, the currently loaded saved search.',
    'search-in-remarks': 'Searching across entries for specific remarks will drastically increase search time.\nContinue?',
    'search-more-specific-criteria': '<h4>If you have more information, you can make future searches faster by using more specific criteria.</h4>',
    'search-has-no-result': 'Search found no results.',
    'search-only-matching-files-no-help': 'All files will be included with each entry.',
    'search-filename-help': `
        <b>Filename</b> allows you to filter entries to only those having filenames that <b><i>contain</i></b> the specified text.<br /> You can then also specify to only return the matching files with each entry.<br />
        <strong><em>Your search will take longer to complete when using this filter.</em></strong>
    `,
    'save-search-help-no-columns': 'All filters will be saved.',
    'save-search-help': 'All filters and grid options (column selection, files per entry, etc) will be saved.',

    // template
    'search-export-limit': (words) => `Export is limited to ${words[0]} results. If you need to export result, please narrow your search criteria and try again.`,
    'search-export-limit-exceeded': (words) => `The number of results is too large for export. Please apply additional filters to reduce the number of items to less than ${words[0]}.`,
    'search-building-result': (words) => `Search found ${words[0]} possible matching entries. Building results...`,
    'search-only-matching-files-yes-help': (words) => `Only files matching the above <b>${words[0]}</b> filter will be included with each entry.`,
    'search-filter-help': (words) => `Choose from the filter conditions, below, then click <b>${words[0]}</b>. Click <b>${words[1]}</b> to remove all filters. Click <b>${words[2]}</b> to save this search for future use.`,
};
